import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const templatePreviewHtmlReducer: RemoteReducer<string> =
  createRemoteReducer("templatePreviewHtml")
